import { type Component, For, createSignal, createEffect } from "solid-js";
import { currentText } from "../lib/store.ts";

const MAX_HISTORY = 5;

const History: Component = () => {
  const [items, setItems] = createSignal<string[]>([]);

  // When currentText changes to a new non-empty value, push the *previous*
  // value to history.
  let prevText = "";
  createEffect(() => {
    const text = currentText();
    if (text && prevText && text !== prevText) {
      setItems((prev) => {
        const trimmed =
          prevText.length > 100 ? prevText.slice(0, 100) + "\u2026" : prevText;
        const next = [trimmed, ...prev];
        return next.slice(0, MAX_HISTORY);
      });
    }
    prevText = text;
  });

  return (
    <div id="history">
      <For each={items()}>
        {(item) => <div class="h-item show">{item}</div>}
      </For>
    </div>
  );
};

export default History;
